import axios, { InternalAxiosRequestConfig } from 'axios';
import { localStorageGet } from '../utils/localStorage';

const env = localStorageGet('environment') ?? 'prod';
/**
 * Pre-configured instance of Axios
 */
const axiosInstance = axios.create({
  // Use Local storage to override API base path
  baseURL: getBaseUrl(`${env}`),
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getBaseUrl(env: string) {
  return '';
  // return process.env.API_URL_PROD;
  // return "http://12.108.254.108:8380/";
  // return "/api/";
}

axiosInstance.interceptors.request.use(
  (
    request: InternalAxiosRequestConfig<any>
  ): InternalAxiosRequestConfig<any> => {
    request!.headers!.Authorization = `Bearer ${localStorageGet('token')}`;
    return request;
  },
  (error) => Promise.reject(error)
);

/**
 * Interceptor to automatically logout current user if any API call returns 401
 * Also handles 403 Forbidden errors for RBAC permission checks
 */
axiosInstance.interceptors.response.use(
  async (res) => {
    const {
      data: { code: status },
    } = res;
    const response: any = { ...res };
    if (Number(status) === 401) {
      console.log('Token Expired');
      console.log('Token Refreshed');
      return axios.request(response.request);
    }
    if (Number(status) === 403) {
      // Handle 403 Forbidden - permission denied
      const { logger } = await import('../utils/common');
      logger.show_error('You do not have permission to perform this action.');
    }
    if (Number(status) === 400 || !response.data.success) {
      if (response.message && response.message.length > 0) {
        response.data.message = response.message;
      }
    }
    return response;
  },
  async (err) => {
    // Handle 403 errors from HTTP status code
    if (err?.response?.status === 403) {
      const { logger } = await import('../utils/common');
      logger.show_error('You do not have permission to perform this action.');
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
